import React from 'react';
import cx from 'classnames';

const Checkbox = ({
  checked,
  className,
  describedby,
  disabled,
  id,
  isError,
  name,
  onChange,
  required,
  value,
}) => {
  const classes = cx({
    'Checkbox': true,
    'is-error': isError,
  }, className);

  return (
    <input
      aria-describedby={ describedby }
      aria-disabled={ disabled }
      checked={ checked }
      className={ classes }
      disabled={ disabled }
      id={ id }
      name={ name }
      onChange={ onChange }
      required={ required }
      type='checkbox'
      value={ value } />
  );
};

Checkbox.defaultProps = {
  disabled: false,
  isError: false,
  required: false,
};

export default Checkbox;
